export default "__VITE_ASSET__DJ_YYEk___"